module.exports = __webpack_public_path__ + "img/dingwei.26ebdacc.svg";